import {
  faTimesCircle,
  faExclamationCircle,
  faInfoCircle,
  faChevronRight,
  faLockAlt,
} from '@fortawesome/pro-solid-svg-icons';
// import fontawesome from "@fortawesome/fontawesome";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState, useRef } from 'react';
import FocusLock from 'react-focus-lock';

import './Modal.css';

import { useTranslation } from 'react-i18next';

import DropDownCalendar from '../../individualReport/pages/components/DropDownCalendar';
import { Button } from '../components/button/Button';
import useKeyboardAction from '../hooks/useKeyboardAction';
import Backdrop from '../menu/Backdrop';

function Modal(props) {
  const [activeReason, setActiveReason] = useState('Reason for leaving');
  const [removeAcct, setRemoveAcct] = useState('Remove account');
  const [style, setStyle] = useState('disabled');
  const [followUp, setFollowUp] = useState();
  const [userText, setUserText] = useState();
  const [placeholderText, setPlaceholderText] = useState('');
  const { t } = useTranslation();
  const {
    modalIsOpen,
    modalText,
    questionTitle,
    onModalClose,
    removeAccount,
    deleteAccount,
    deleteUser,
    error,
  } = props;

  let modalText1 = '';
  let modalText2 = '';
  // check if modal text is a string (standard modal) or an html (individual report copy), otherwise it's an object with the main and secondary copy (pop-up with an array of boxes from assessement)
  if (removeAccount) {
    modalText1 =
      'Once you remove your account, you will no longer have access to Champion Health and your account and personal health data will be permanently deleted. <br /> <br />Please note, this will also remove any friend or family profiles associated with your account, and they will no longer have access to the platform.';
  } else if (modalText && (typeof modalText === 'string' || modalText.type === 'div')) {
    modalText1 = modalText;
  } else if (modalText && modalText.main && modalText.secondary) {
    modalText1 = modalText.main;
    modalText2 = modalText.secondary;
  }

  const modalClickHandler = () => {
    onModalClose(false);
    if (activeReason) {
      setActiveReason('Reason for leaving');
      setFollowUp('');
    }
    if (removeAcct === 'Confirm remove') {
      setRemoveAcct('Remove account');
    }
  };

  const toggleActiveReason = (region) => {
    setActiveReason(region);
  };

  let deleteClass = '';
  if (deleteAccount) {
    deleteClass = 'user_delete';
  }

  const modalRef = useRef(null);

  useKeyboardAction(() => {
    modalClickHandler();
  }, 'Escape');

  useEffect(() => {
    if (modalIsOpen && modalRef.current) {
      const checkModalSize = () => {
        setTimeout(() => {
          if (!modalRef.current) return;
          const screenWidth = window.innerWidth;
          if (screenWidth <= 750) return;

          const modalRect = modalRef.current.getBoundingClientRect();
          const modalHeight = modalRect.height;
          const windowHeight = window.innerHeight;
          if (modalHeight > windowHeight * 0.8) {
            if (window.scrollY > 0) {
              window.scroll(0, 0);
            }
            modalRef.current.style.position = 'absolute';
            modalRef.current.style.top = '50px';
            modalRef.current.style.left = '50%';
            modalRef.current.style.transform = 'translateX(-50%)';
            modalRef.current.style.marginLeft = '0';
          }
        }, 100);
      };

      checkModalSize();
    }
  }, [modalIsOpen]);

  useEffect(() => {
    if (document.getElementById('remove_btn')) {
      const button = document.getElementById('remove_btn');
      if (activeReason === 'Reason for leaving') {
        button.disabled = true;
        setStyle('disabled');
      } else {
        button.disabled = false;
        setStyle('');
      }
    }
  }, [activeReason]);

  const deleteBtnHandler = () => {
    if (activeReason === 'Other' && !userText) {
      setPlaceholderText('Please enter your reason for leaving...');
    } else if (activeReason === 'Other' && userText.length < 4) {
      setUserText('');
      setPlaceholderText('Please enter your reason for leaving...');
    } else if (activeReason === 'Other' && userText) {
      if (removeAcct === 'Remove account') {
        setRemoveAcct('Confirm remove');
      } else {
        deleteUser({ reason: `Other: ${userText}`, platform: 'web' });
        modalClickHandler();
      }
    } else if (removeAcct === 'Remove account') {
      setRemoveAcct('Confirm remove');
    } else {
      deleteUser({ reason: activeReason, platform: 'web' });
      modalClickHandler();
    }
  };

  const addFollowUp = (followUpData) => {
    setFollowUp(followUpData);
  };

  const handleTextAreaChange = (event) => {
    setUserText(event.target.value);
  };

  return (
    <Backdrop open={`${modalIsOpen ? 'open' : 'closed'}`} onBackdropClose={modalClickHandler}>
      <FocusLock returnFocus>
        <div
          ref={modalRef}
          id="modal-container"
          className={`${modalIsOpen ? `open ${deleteClass}` : 'closed '}`}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
        >
          <Button
            ariaLabel={t('modal.close')}
            className="close-icon standard-modal-close-icon"
            icon={{ faIconDefinition: faTimesCircle }}
            onClick={modalClickHandler}
            variant="icon-only"
            color="white"
          />
          <h2 id="modal-title">
            {modalText === t('A072') ? t('modal.assessment.error') : questionTitle}
          </h2>
          {removeAccount ? (
            <FontAwesomeIcon icon={faExclamationCircle} className="icon modal" />
          ) : (
            <FontAwesomeIcon icon={faInfoCircle} className="icon modal" />
          )}
          {typeof modalText1 === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: modalText1 }} />
          ) : (
            modalText1
          )}
          {modalText && error && <div dangerouslySetInnerHTML={{ __html: modalText }} />}
          {modalText2 &&
            modalText2.map((item) =>
              typeof item === 'string' ? (
                <div className="modal_mappedBoxes" key={item.key}>
                  {item.value}
                </div>
              ) : (
                <div
                  className="modal_mappedBoxes"
                  dangerouslySetInnerHTML={{ __html: item.value }}
                />
              )
            )}
          {removeAccount && removeAcct === 'Remove account' && (
            <div className="delete_account">
              <DropDownCalendar
                assessmentDate={activeReason}
                dates={modalText}
                show="deleteAccount"
                setAssessmentDate={toggleActiveReason}
                addFollowUp={addFollowUp}
                profile
                deleteAccount
              />
            </div>
          )}
          {followUp &&
            removeAcct === 'Remove account' &&
            followUp.map((item, index) => {
              if (item.startsWith('ICON')) {
                // delete ICON and add lock icon
                const div = item.slice(4);
                return (
                  <div className="list_item" key={index}>
                    <FontAwesomeIcon icon={faLockAlt} className="icon modal_list" />
                    <div dangerouslySetInnerHTML={{ __html: div }} />
                  </div>
                );
              }
              if (item.startsWith('>')) {
                // delete chevron and add icon
                const div = item.slice(1);
                return (
                  <div className="list_item" key={index}>
                    <FontAwesomeIcon icon={faChevronRight} className="icon modal_list" />
                    <div dangerouslySetInnerHTML={{ __html: div }} />
                  </div>
                );
              }
              if (item.startsWith('input')) {
                return (
                  <textarea
                    key={index}
                    className="modal_input_field"
                    type="text"
                    required
                    minLength="4"
                    value={userText}
                    onChange={handleTextAreaChange}
                    placeholder={placeholderText}
                  />
                );
              }
              return (
                <p className="main_point" key={index} dangerouslySetInnerHTML={{ __html: item }} />
              );
            })}

          {!removeAccount && (
            <button type="button" className="modal_close" onClick={modalClickHandler}>
              {t('AT007')}
            </button>
          )}
          {removeAccount && (
            <>
              <button
                type="button"
                className="modal_close cancel_account"
                onClick={modalClickHandler}
              >
                Cancel
              </button>
              <button
                type="button"
                id="remove_btn"
                className={`modal_close remove_account ${style}`}
                onClick={deleteBtnHandler}
              >
                {removeAcct}
              </button>
            </>
          )}
        </div>
      </FocusLock>
    </Backdrop>
  );
}
export default Modal;
